<template>
    <v-app>
        <template v-if="loading">
            <v-main>
                <v-container fluid class="fill-height">
                    <v-row justify="center" align="center">
                        <v-col class="text-center" xs="12" md="12">
                            <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-col>

                        <v-col class="text-center">
                            {{ $t('app-layout.texts.loading-application') }}
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </template>

        <template v-else>
            <v-app-bar app class="elevation-0">
                <v-icon @click.stop="drawer = !drawer" class="mr-5">
                    {{ drawer ? 'mdi-menu-open' : 'mdi-menu' }}
                </v-icon>

                <v-toolbar-title>{{ applicationName }}</v-toolbar-title>

                <div class="flex-grow-1"></div>

                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-btn icon @click="logout" v-on="on">
                            <v-icon>mdi-logout-variant</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('app-layout.texts.exit') }}</span>
                </v-tooltip>
            </v-app-bar>

            <navigation-drawer
                :drawer="drawer"
                @change="drawerVisibilityChanged"
            ></navigation-drawer>
            <filter-drawer />

            <v-main>
                <breadcrumb />

                <v-fade-transition hide-on-leave>
                    <router-view></router-view>
                </v-fade-transition>

                <notification-handler></notification-handler>
            </v-main>
        </template>
    </v-app>
</template>

<script>
import NavigationDrawer from '@/components/drawer/NavigationDrawer'
import FilterDrawer from '@/shared/components/filters/FilterDrawer'
import NotificationHandler from '@/components/notifications/NotificationHandler'

export default {
    components: {
        'navigation-drawer': NavigationDrawer,
        'filter-drawer': FilterDrawer,
        'notification-handler': NotificationHandler,
    },

    data: vm => {
        return {
            //Verifica o breakpoint para setar drawer aberto ou fechado ao iniciar a aplicação
            drawer:
                vm.$vuetify.breakpoint.name === 'xs' ||
                vm.$vuetify.breakpoint.name === 'sm' ||
                vm.$vuetify.breakpoint.name === 'md'
                    ? false
                    : true,
            filterDrawer: false,
            loading: true,
        }
    },

    methods: {
        drawerVisibilityChanged(value) {
            this.drawer = value
        },

        async logout() {
            await this.$store.dispatch('auth/logout')

            this.$router.push({ name: 'login' })
        },
    },

    async created() {
        this.loading = false
    },

    computed: {
        applicationName() {
            return this.$store.getters['reseller/isWhiteLabel']
                ? this.$t('app-layout.texts.whitelabel')
                : this.$t('app-layout.texts.resale')
        },
    },
}
</script>
